import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";
import { technologySpecOptions } from "../../InterfacesAndComponents/stringUtils";

const ViewVirtualCardOverview = ({ data }) => {
  const {
    view_virtual_card_would_you_like_i2c_hosted_view_virtual_card,
    view_virtual_card_technology_specification_for_i2c_web_view_integration,
    view_virtual_card_technology_specification_for_i2c_web_view_integration_other,
    view_virtual_i2c_hosted_web_view_language,
    view_virtual_i2c_hosted_web_view_language_other,
  } = data["3_8"];

  const techValue = [
    ...(
      view_virtual_card_technology_specification_for_i2c_web_view_integration ??
      []
    )
      .filter((l) => l?.length && l !== "other")
      .map((value) => technologySpecOptions.find(opt => opt.value === value)?.label || toTitleCase(value)),
    ...(view_virtual_card_technology_specification_for_i2c_web_view_integration?.includes(
      "other",
    ) &&
    view_virtual_card_technology_specification_for_i2c_web_view_integration_other?.length
      ? [
          `Other (${toTitleCase(view_virtual_card_technology_specification_for_i2c_web_view_integration_other)})`,
        ]
      : []),
  ].join(", ");

  const languageValue = [
    ...(view_virtual_i2c_hosted_web_view_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(view_virtual_i2c_hosted_web_view_language?.includes("other") &&
    view_virtual_i2c_hosted_web_view_language_other?.length
      ? [
          `Other (${toTitleCase(view_virtual_i2c_hosted_web_view_language_other)})`,
        ]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="Web View / Virtual Card" />
        </div>
        <ReviewAttribute
          label="Would you like i2c hosted View Virtual Card?"
          value={
            view_virtual_card_would_you_like_i2c_hosted_view_virtual_card?.length
              ? toTitleCase(
                  view_virtual_card_would_you_like_i2c_hosted_view_virtual_card,
                )
              : "-"
          }
        />
        <ReviewAttribute
          label="Technology Specification for i2c Web View Integration"
          value={techValue || "-"}
        />
        <ReviewAttribute
          label="i2c Hosted Web View Language"
          value={languageValue || "-"}
        />
      </div>
      <div className="divider-bottom mt-16"></div>
    </div>
  );
};
export default ViewVirtualCardOverview;
